<div class="content-container">
  <!-- Main View -->
  <main class="main-view">
    <vi-ui-alert-message [type]="AlertMessageType.ERROR"
      [content]="resources?.accountUnavailableDialog_Arm_Text">
    </vi-ui-alert-message>
  </main>
</div>
